import { render, staticRenderFns } from "./product-details-projects.vue?vue&type=template&id=c58c55fe&scoped=true&"
import script from "./product-details-projects.vue?vue&type=script&lang=js&"
export * from "./product-details-projects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58c55fe",
  null
  
)

export default component.exports